'use client';

import { Skeleton } from '@/components/ui/skeleton';
import { useSkeletonMorphSource } from '@/components/ui/use-skeleton-morph';
import { SKELETON_BLOCK_ATTR } from '@/lib/skeleton-morph';
import { useRef } from 'react';

export function ThreadsSidebarSkeleton() {
  const rootRef = useRef<HTMLDivElement>(null);
  useSkeletonMorphSource(rootRef, 'sidebar');
  const block = { [SKELETON_BLOCK_ATTR]: '' };
  return (
    <div
      ref={rootRef}
      data-thread-sidebar-surface="skeleton"
      className="flex h-full flex-col gap-3 p-3"
    >
      <Skeleton {...block} className="h-8 w-8 rounded-full" />
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton key={index} {...block} className="h-8 w-full" />
      ))}
    </div>
  );
}
